import { BaseEntity } from './BaseEntity'

export class RHDigitalSectorEntity extends BaseEntity {
    constructor() {
        super()

        this.entityName = 'components.rhdigital.list.sectors.entity'
        this.APIRoute = 'Resources/RHDigital/Sectors'
        this.i18nBase = 'components.rhdigital.list.sectors'
        this.customActions = { duplicate: false }

        this.tableColumns = [
            { key: 'nome', label: 'components.rhdigital.list.fields.nome', visible: true, orderBy: true },
            { key: 'departamento', label: 'components.rhdigital.list.fields.departamento', visible: true, orderBy: true },
            { key: 'lider', label: 'components.rhdigital.list.fields.lider', visible: true, orderBy: true },
            { key: 'colaboradores', label: 'components.rhdigital.list.fields.colaboradores', visible: true, orderBy: true },
            { key: 'status', label: 'common.labels.status', visible: true, orderBy: false },
            { key: 'actions', label: 'common.labels.actions', visible: true, orderBy: false },
        ]

        this.pages = {
            create: { route: ['/rhdigital/sectors'] },
            edit: { route: ['/rhdigital/sectors'] },
            list: {
                pageTitle: 'components.rhdigital.list.sectors.title',
                pathI18n: 'components.settings.permissionManagement.menuList.Sectors',
                route: ['/rhdigital/sectors'],
                filters: {
                    quickSearch: {
                        info: 'common.messages.info.searchByName',
                        searchBy: ['nome'],
                        type: 'text',
                    },
                    advanced: {
                        fields: [
                            {
                                key: 'status',
                                label: 'common.labels.status',
                                type: 'select',
                                options: [
                                    { label: 'common.labels.active', value: true },
                                    { label: 'common.labels.inactive', value: false },
                                ],
                                path: 'status',
                            },
                        ],
                    },
                },
            },
        }
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint
        Object.keys(params).forEach((key) => {
            url = url.replace(`:${key}`, params[key])
        })
        return url
    }
}
